module.exports = __webpack_public_path__ + "static/media/sherlockhr.d4d91743.svg";